import qs from 'query-string';
import { AUDIO_PROXY_SERVICE_BASEURL } from 'config';
import ServiceFactory from 'services/ServiceFactory/ServiceFactory';
import { AUDIO_PROXY_PATH, AUDIO_PROXY_FORWARDING_PATH } from './constants';
import { ProxyMediaArgs } from './types';

const serviceFactory = new ServiceFactory(AUDIO_PROXY_SERVICE_BASEURL);

/**
 * GET endpoint for media proxy forwarding. Use `.url(args)` for the full URL,
 * or call with args to fetch; response is a Blob by default.
 */
export const getProxyMediaEndpoint = serviceFactory.createGetEndpoint(
  AUDIO_PROXY_FORWARDING_PATH,
)<ProxyMediaArgs, Blob, Blob>({
  disableAuthHeader: true,
  responseType: 'blob',
  queryParams(args: ProxyMediaArgs) {
    return {
      url: qs.stringifyUrl({
        url: args.url,
        query:
          args.appendXRequestQuery !== false
            ? { 'x-request': 'xhr' }
            : undefined,
      }),
      forwardReferrer: true,
      useRemoteProxy: true,
    };
  },
});

export const getExternalMediaSize = serviceFactory.createHeadEndpoint(
  AUDIO_PROXY_PATH,
)({
  disableAuthHeader: true,
  queryParams(srcUrl: string) {
    const remoteUrl = qs.stringifyUrl({
      url: srcUrl,
      // https://serverfault.com/questions/856904/chrome-s3-cloudfront-no-access-control-allow-origin-header-on-initial-xhr-req/856948#856948
      query: { 'x-request': 'xhr' },
    });

    return { url: remoteUrl };
  },
  select(result) {
    return parseFloat(result.contentLength ?? '');
  },
});
